import styled from 'styled-components';
import colors from 'Styles/colors';
import { ReactComponent as Config } from 'Images/icon-customfields.svg';
import { ReactComponent as Token } from 'Images/icon-action-bar-token.svg';
import { ReactComponent as Trash } from 'Images/icon-action-bar-trash.svg';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 15px 0 11px 10px;
  background-color: ${({ theme }) => theme.backgrounds.actionBar};
  border-bottom: 1px solid  ${({ theme }) => theme.borders.tableHeaderTop};
`;
Wrapper.displayName = 'Wrapper';

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
  height: 37px;
`;
ButtonWrapper.displayName = 'ButtonWrapper';

export const Title = styled.div`
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.08;
  letter-spacing: normal;
  color: #1c2b43;
  user-select: none;
`;
Title.displayName = 'Title';

export const ConfigIcon = styled(Config)`
  g, g > path {
    fill: ${({ theme }) => theme.icons.agentsActionBar.color} !important;
  }
  &:hover {
    g, path {
      fill: ${({ theme }) => theme.icons.actionBar.hover} !important;
    }
  }
`;

ConfigIcon.displayName = 'ConfigIcon';

export const TokenIcon = styled(Token)`
  g, g > path {
    fill: ${({ theme }) => theme.icons.agentsActionBar.color} !important;
  }
  &:hover {
    g, path {
      fill: ${({ theme }) => theme.icons.actionBar.hover} !important;
    }
  }
`;

TokenIcon.displayName = 'TokenIcon';

export const TrashIcon = styled(Trash)`
  height: 17px;
  g, g > path {
    fill: ${colors.red1} !important;
  }
`;

Trash.displayName = 'Trash';

export const RightWrapper = styled.div`
  margin: 0 11px 0 auto;
`;
RightWrapper.displayName = 'RightWrapper';
